import InviteeLists from "../../InviteeSection/InviteeLists";
import Reveal from "../Reveal";
import Section from "./Section";

/**
 * The family lists, shared with every theme through InviteeLists (same lists, same
 * conditions); renders nothing when none are filled.
 */
const Blessings = () => (
  <InviteeLists>
    {(lists) => (
      <Section
        className="ut-families"
        label="With blessings from our families"
        deco={["toran", "petals"]}
        tone="blush"
        seed={77}
        kicker="With Love & Blessings"
        title="Our Families"
      >
        <div className="ut-families__lists">
          {lists.map(({ title, names }, i) => (
            <Reveal key={title} className="ut-family" delay={0.1 + i * 0.12}>
              <p className="ut-kicker ut-family__title">{title}</p>
              <p className="ut-family__names">{names}</p>
            </Reveal>
          ))}
        </div>
      </Section>
    )}
  </InviteeLists>
);

export default Blessings;
